import React from 'react';
import ReactDOM from 'react-dom';

ReactDOM.render(
  <>
  <h1>Hello world</h1>
  <h1>Shivam kumar singh</h1>
  </>,
  document.getElementById('root')
);